import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type UpdateOrderItemsRequest as SchemaUpdateOrderItemsRequest } from '../schemas/UpdateOrderItemsRequest';
import { type UpdateOrderItemsResult as SchemaUpdateOrderItemsResult } from '../schemas/UpdateOrderItemsResult';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Обновление количества товаров в заказе
 */
export const UpdateOrderItemsContentType = 'application/json' as const;
export type UpdateOrderItemsRequest = SchemaUpdateOrderItemsRequest;
export type UpdateOrderItemsResponses = LinkCommonErrorResponses & {
    /**
     * @description Update order items result
     */
    '200': {
        'application/json': SchemaUpdateOrderItemsResult;
    };
};
export type UpdateOrderItemsResponseSuccess = UpdateOrderItemsResponses['200']['application/json'];
export type UpdateOrderItemsSearchParams = {
    signature: string;
};
export type UpdateOrderItemsPathParameters = {
    order_id: string;
    store_slug: string;
};
export const UpdateOrderItemsUrl = '/{store_slug}/orders/{order_id}/items' as const;
export const UpdateOrderItemsMethod = 'PATCH' as const;
export const getUpdateOrderItemsUrl = (params: UpdateOrderItemsPathParameters) =>
    UpdateOrderItemsUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateOrderItemsPathParameters) =>
        String(params[param])
    );
